import Int32LookupRequestModel from '../../generated/types/model/resource/Int32LookupRequestModel';

export default class Int32LookupRequestViewModel extends Int32LookupRequestModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
